(function () {
  'use strict';
  if (window.kmWelcomeInitialized) return;
  window.kmWelcomeInitialized = true;
  var helper;
  function loadHelper() {
    if (window.jotformEmbedHandler) return Promise.resolve();
    if (helper) return helper;
    helper = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return helper;
  }
  function init(scope) {
    scope.querySelectorAll('[data-kwc-jotform]').forEach(function (frame) {
      if (frame.dataset.autoResize !== 'true' || frame.dataset.kwcReady) return;
      frame.dataset.kwcReady = 'true';
      loadHelper().then(function () {
        if (!frame.isConnected || !window.jotformEmbedHandler) return;
        window.jotformEmbedHandler("iframe[id='" + frame.id + "']", 'https://form.jotform.com/');
      }).catch(function () {
        // Permit a later editor reload to retry the official helper.
        delete frame.dataset.kwcReady;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
